export default __webpack_public_path__ + "static/media/Corp.54121544.svg";